import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import React from 'react';

import { UIDialogTitle } from '@/shared/components';
import { muiPalette } from '@/shared/general-theme';

interface Props {
  keyId: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  itemName?: string;
}

const DeletePopup: React.FC<Props> = ({
  keyId,
  isOpen,
  onClose,
  onConfirm,
  title = 'Delete',
  itemName = 'this item',
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };
  return (
    <Dialog
      key={keyId}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth='xs'
    >
      <UIDialogTitle
        id={`dialog-title-${keyId}`}
        title={title}
        onCloseBtnAction={onClose}
        sx={{ color: muiPalette.error.dark }}
      />

      <DialogContent
        id={`dialog-content-${keyId}`}
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography variant={'subtitle1'}>
          {'Are you sure you want to delete '}
          <b>{itemName}</b>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant='outlined'
          color='secondary'
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='error'
          onClick={handleConfirm}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopup;